module.exports = __webpack_public_path__ + "static/media/amazon.736072f6.jpg";